<h2 mat-dialog-title>
  {{ "brand.campaign.summary.preview.title" | translate }}
  <span class="close-icon" [mat-dialog-close]="">
    <mat-icon>close</mat-icon>
  </span>
</h2>
<mat-dialog-content>
  <div class="campaign-item-container">
    <div class="campaign-item">
      <div
        class="campaign-item-img"
        [ngStyle]="{
          'background-image': 'url(' + firstCampaignImageFile + ')'
        }"
      >
        <div class="campaign-item-status">
          <img
            alt="campaign-{{
              STATUS_ATTRS[campaign.campaignBrandStatus]?.label | translate
            }}"
            class="status-icon"
            src="/assets/images/icons/{{
              STATUS_ATTRS[campaign.campaignBrandStatus]?.icon
            }}.svg"
          />
          <span>{{
            STATUS_ATTRS[campaign.campaignBrandStatus]?.label | translate
          }}</span>
        </div>
      </div>
      <div class="campaign-item-body">
        <div>
          <div class="campaign-item-name">{{ campaign.name }}</div>
          <span class="campaign-type">{{
            "shared.campaignType." + campaign.type | translate
          }}</span>
          <div class="fixed-height-details">
            <div class="campaign-item-period">
              <mat-icon>insert_invitation</mat-icon>
              <span
                class="campaign-item-dates"
                *ngIf="campaign.startDate && campaign.endDate"
              >
                {{ "shared.fromDate" | translate
                }}<span class="date">{{
                  campaign.startDate | localizeDate
                }}</span>
                {{ "shared.toDate" | translate
                }}<span class="date">{{
                  campaign.endDate | localizeDate
                }}</span>
              </span>
              <span
                class="campaign-item-dates"
                *ngIf="!campaign.startDate || !campaign.endDate"
              >
                {{ "brand.campaign.summary.datesToBeConfirmed" | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
